import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IRootFormBuilderUiStore } from '../RootFormBuilderUiStore';
import IMobxProviderContext from '../interfaces/IMobxProviderContext';

const useFormBuilderUiStore = (): IRootFormBuilderUiStore => useContext<IMobxProviderContext>(MobXProviderContext as any).rootFormBuilderUiStore;

export default useFormBuilderUiStore;
